module.exports = __webpack_public_path__ + "static/media/D8F4B9F2-551E-498E-9760-3E2CB5EC1297.b125b647.bin";